//*************Interfaces******************//
import { PointsByPosition } from "api/model/PointsByRaceConfiguration";

interface PointSystem {
    [classID: string]: PointsByPosition[];
}

export interface RaceConfiguration {
    durationType: DurationType;
    duration: number;
    weather?: string;
    timeOfDay: string;
    invertedPositions: number;
    pointSystem?: PointSystem;
}

//*****************************************//

//*************Enums***********************//
export enum DurationType {
    LAPS = "LAPS",
    MINUTES = "MINUTES",
}
//*****************************************//

export const durationTypeDescription = (durationType?: DurationType) => {
    if (durationType === DurationType.LAPS) {
        return "Voltas";
    }
    if (durationType === DurationType.MINUTES) {
        return "Minutos";
    }
    return "";
};

//*************Default values**************//
export const RaceConfigDefaultValues: RaceConfiguration = {
    durationType: DurationType.MINUTES,
    duration: 0,
    weather: "",
    timeOfDay: "",
    invertedPositions: 0,
    pointSystem: {},
};
//*****************************************//
